import { substring } from 'stringz'
import _ from 'lodash'
const getLength = require('utf8-byte-length')
export const getClampText = (keyword, limitLength) => {
  if (getLength(keyword) > limitLength) {
    return substring(keyword, 0, limitLength) + '...'
  }
  return keyword
}
export const replaceSpecialCharacters = (string) => {
  const regExp = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi
  return _.replace(string, regExp, '') // ?
}
